import { useFilledSlots as useFilledSlotsContextState } from '../../context/ads/filled.context'
import useDebounce from '../useDebounce'

const useFilledSlots = () => {
    const [filledSlots, setFilledSlots] = useFilledSlotsContextState()
    return [useDebounce(filledSlots, 50), setFilledSlots] as const
}

export default useFilledSlots
